<template>
    <div>
        <div class="page-header">
            <img class="avatar" v-if="userInfo.member && userInfo.member.headimgurl" :src="userInfo.member.headimgurl">
            <van-icon v-else class="avatar" name="manager-o" />
            <div class="page-header-title">
                <h5 class="site-desc">账号：{{userInfo.username}}</h5>
                <p class="site-desc">电话：{{userInfo.mobile}}</p>
                <p class="site-desc" v-if="userInfo.member">微信：{{userInfo.member.nickname}}</p>
                <p class="site-desc" v-else>未获取到微信昵称</p>
                <span class="logout-btn" @click="logout">退出</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "App",
        data: () => ({
            token: '',
            userInfo:{}
        }),
        watch: {},
        created() {
            this.fetchData('/account/info',{},(res)=>{
                this.userInfo = res.data
            })
        },
        methods: {
            logout(){
                sessionStorage.clear();
                this.$router.push({name:"login"})
            }
        }
    };
</script>
<style>
    .logout-btn{
        width: 40px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #75b2f9;
        font-size: 12px;
        padding: 1px 3px;
        border: 1px solid #75b2f9;
        position: absolute;
        top: 10px;
        right: 10px;
    }
    body, html {
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        padding: 0;
        margin: 0;
        padding-bottom: .3rem;
    }

    .page-header {
        height: 2.5rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background: -webkit-gradient(linear, left top, left bottom, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(#3c6bff, #75b2f9);
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
        box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
    }

    .page-header .avatar {
        margin: 0 .2rem 0 .5rem;
        background: #fff;
        color: #75b2f9;
        width: 1rem;
        height: 1rem;
        padding: .1rem;
        border-radius: 2rem;
        border: .05rem solid #75b2f9;
    }

    .page-header .page-header-title {
        color: #fff;
        font-weight: 700;
        text-align: left;
        padding-left: .2rem;
    }

    .page-header .page-header-title .site-title {
        padding: 0;
        margin: 0;
        font-size: .5rem;
        line-height: .5rem;
    }

    .page-header .page-header-title .site-desc {
        margin: .1rem 0;
        padding: 0;
        font-size: .3rem;
    }

    .home-nav {
        width: 6.74rem;
        margin: auto;
        padding-top: .1rem;
        padding-bottom: .1rem;
        background: #fff;
        border-radius: .1rem;
        box-shadow: 0 0 0.02rem #dedede;
    }

    .home-nav img {
        margin: 0;
        width: .8rem;
        height: .8rem;
    }

    .home-nav p {
        margin-top: -.1rem;
        font-size: .22rem;
        color: #555;
    }

    .page-footer {
        bottom: .3rem;
        font-size: .16rem;
        color: #555;
        text-align: center;
        width: 7.5rem;
    }

    .page-footer a {
        color: #666;
        text-decoration: #3a8ee6;
    }

    .warm-tips {
        font-size: .25rem;
        margin: 0 .3rem;
        padding: 0 .3rem;
    }

    .warm-tips h5 {
        text-align: left;
        margin: .2rem 0;
        padding-left: .1rem;
        font-size: .3rem;
        border-left: .2rem solid #75b2f9;
    }

    .warm-tips ol {
        text-align: left;
        padding: 0;
        font-size: .24rem;
    }

    .warm-tips ol li {
        list-style: disc;
        line-height: .4rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/header.vue